import React from "react";
import styles from "./Clients.module.scss";
import ClientsTable from "../../../components/Admin/ClientsTable/ClientsTable";
import { IoMdRefresh } from "react-icons/io";

const Clients = () => {
  return (
    <div className={styles.clients}>
      <h1 className={styles.title}>
        Управление пользователями{" "}
        <span className={styles.pointer}>
          <IoMdRefresh />
        </span>
      </h1>
      <div className={styles.table}>
        <ClientsTable />
      </div>
    </div>
  );
};

export default Clients;
